import { render, staticRenderFns } from "./AuthSimple.vue?vue&type=template&id=31a19355&scoped=true"
import script from "./AuthSimple.vue?vue&type=script&lang=ts"
export * from "./AuthSimple.vue?vue&type=script&lang=ts"
import style0 from "./AuthSimple.vue?vue&type=style&index=0&id=31a19355&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a19355",
  null
  
)

export default component.exports